// TDIC - getProxiedUrl is addded based on requirement
import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';

export default class FNOLService {
    static submitClaim(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'),
            'submitClaim', [data], additionalHeaders);
    }
    /* TDIC - Following method has changed based on requirement.
    static getFNOLDetails(policyNumber, data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'),
            'createClaim', [policyNumber, data], additionalHeaders);
    }*/

    // TDIC - Added - Following method to get FNOL details
    static getFNOLDetails(policyNumber, data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnolExt'),
            'createClaim_Ext', [policyNumber, data], additionalHeaders);
    }

    /* TDIC - Following method has changed based on requirement.
    static getClaim(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'),
            'getClaim', [claimNumber], additionalHeaders);
    }*/

    // TDIC - Added - Following method to get claim.
    static getClaim(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnolExt'),
            'getClaim_Ext', [claimNumber], additionalHeaders);
    }

    /* Following method has changed based on requirement.
     static saveFNOLDetails(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnol'),
            'saveClaim', [data], additionalHeaders);
    } */

    // TDIC - Added - Following method to save FNOL Details.
    static saveFNOLDetails(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnolExt'),
            'saveClaim_Ext', [data], additionalHeaders);
    }

    /* TDIC - Following method has changed based on requirement.
    static searchPolicies(policySearchCriteria, additionalHeaders = {}) {
        return JsonRPCService
        .send(getProxiedServiceUrl('fnolPolicy')
        , 'searchPolicies', [policySearchCriteria], additionalHeaders);
    }*/
    // TDIC - Added - Following method to search policies.
    static searchPolicies(policySearchCriteria, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnolExtPolicy'), 'searchPolicies_Ext', [policySearchCriteria], additionalHeaders);
    }

    static getPolicySummaryRiskUnits(policyNumber, lossDate, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('fnolPolicy'), 'getPolicySummaryRiskUnits', [policyNumber, lossDate], additionalHeaders);
    }

    // TDIC - Added - Following method to get offering code
    static getOfferingCode(policyType, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claimCommonExt'), 'getClaimTypes', [policyType], additionalHeaders);
    }
}
